import React, { useState, useEffect, memo } from "react"
import TopArrowIcon from "../svg/TopArrowIcon"
import "./topArrow.css"

const TopArrow = () => {
  const [showTopBtn, setShowTopBtn] = useState(false)
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 800) {
        setShowTopBtn(true)
      } else {
        setShowTopBtn(false)
      }
    })
  }, [])

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
  return (
    <>
      {showTopBtn && (
        <span
          className="top-arrow"
          onClick={goToTop}
          aria-label="toparrow"
          role="button"
          tabIndex={0}
        >
          <i>
            <TopArrowIcon />
          </i>
        </span>
      )}
    </>
  )
}

export default memo(TopArrow)
